import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  IconButton,
  Link,
  Text,
  useBreakpointValue,
  useColorModeValue,
} from "@chakra-ui/react";
import PropTypes from "prop-types";
import AdminNavbarLinks from "components/navbar/NavbarLinksAdmin";
import { IoMenuOutline } from "react-icons/io5";

export default function AdminNavbar(props) {
  const scrolled = false;
  const location = useLocation();
  const isDesktopMenuButton = useBreakpointValue({ base: false, lg: true });
  const [paginaActual, setPaginaActual] = useState(
    localStorage.getItem("PaginaActual") || "Inicio"
  );

  useEffect(() => {
    const segmento = location.pathname.split("/")[2];
    setPaginaActual(
      !segmento || segmento === "default"
        ? "Principal"
        : segmento.replace(/_/g, " ")
    );
  }, [location]);

  const mainText = useColorModeValue("navy.700", "white");
  const secondaryText = useColorModeValue("gray.700", "white");
  const navbarBg = useColorModeValue(
    "rgba(244, 247, 254, 0.2)",
    "rgba(11,20,55,0.5)"
  );
  const navbarIcon = useColorModeValue("gray.600", "white");
  const handleMenuClick = () => {
    if (isDesktopMenuButton) {
      props.onToggleSidebarCollapse?.();
      return;
    }

    props.onOpen?.();
  };

  return (
    <Box
      position="fixed"
      boxShadow="none"
      bg={navbarBg}
      borderColor="transparent"
      filter="none"
      backdropFilter="blur(20px)"
      backgroundPosition="center"
      backgroundSize="cover"
      borderRadius="16px"
      borderWidth="1.5px"
      borderStyle="solid"
      transitionDelay="0s, 0s, 0s, 0s"
      transitionDuration="0.25s, 0.25s, 0.25s, 0s"
      transitionProperty="box-shadow, background-color, filter, border"
      transitionTimingFunction="linear, linear, linear, linear"
      alignItems={{ base: "stretch", xl: "center" }}
      display="block"
      minH="75px"
      justifyContent={{ xl: "center" }}
      lineHeight="25.6px"
      mx="auto"
      mt="0px"
      pb="8px"
      right={{ base: "8px", md: "16px", lg: "30px", xl: "30px" }}
      px={{ base: "10px", sm: "15px", md: "10px" }}
      ps={{ xl: "12px" }}
      pt="8px"
      top={{ base: "12px", md: "16px", lg: "20px", xl: "20px" }}
      w={props.w}
      maxW={props.maxWidth}
    >
      <Flex
        w="100%"
        gap={{ base: "10px", md: "16px" }}
        flexDirection={{ base: "column", lg: "row" }}
        alignItems={{ base: "stretch", xl: "center" }}
      >
        <Flex align="center" gap={{ base: "10px", md: "14px" }} minW="0">
          <IconButton
            display="inline-flex"
            onClick={handleMenuClick}
            variant="ghost"
            aria-label="Abrir menu"
            minW={{ base: "44px", md: "48px" }}
            w={{ base: "44px", md: "48px" }}
            h={{ base: "44px", md: "48px" }}
            borderRadius="12px"
            color={navbarIcon}
            icon={<IoMenuOutline size="30px" />}
          />
          <Box minW="0">
            <Breadcrumb overflow="hidden">
              <BreadcrumbItem
                color={secondaryText}
                fontSize="sm"
                mb="5px"
                maxW="100%"
              >
                <BreadcrumbLink href="#" color={secondaryText}>
                  Menu
                </BreadcrumbLink>
              </BreadcrumbItem>

              <BreadcrumbItem
                color={secondaryText}
                fontSize="sm"
                mb="5px"
                maxW="100%"
              >
                <BreadcrumbLink href="#" color={secondaryText} noOfLines={1}>
                  {paginaActual}
                </BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>
            <Link
              color={mainText}
              href="#"
              bg="inherit"
              borderRadius="inherit"
              fontWeight="bold"
              fontSize={{ base: "22px", md: "28px", lg: "34px" }}
              lineHeight="1.2"
              wordBreak="break-word"
              display="block"
              _hover={{ color: mainText }}
              _active={{
                bg: "inherit",
                transform: "none",
                borderColor: "transparent",
              }}
              _focus={{
                boxShadow: "none",
              }}
            >
              {paginaActual}
            </Link>
          </Box>
        </Flex>
        <Box ms={{ base: "0", lg: "auto" }} w={{ base: "100%", lg: "auto" }}>
          <AdminNavbarLinks
            onOpen={props.onOpen}
            logoText={props.logoText}
            secondary={props.secondary}
            fixed={props.fixed}
            scrolled={scrolled}
          />
        </Box>
      </Flex>
      {props.secondary ? (
        <Text color="white" mt="8px">
          {props.message}
        </Text>
      ) : null}
    </Box>
  );
}

AdminNavbar.propTypes = {
  brandText: PropTypes.string,
  variant: PropTypes.string,
  secondary: PropTypes.bool,
  fixed: PropTypes.bool,
  onOpen: PropTypes.func,
  onToggleSidebarCollapse: PropTypes.func,
};
